<template>
  <el-dialog
    title="修改币种"
    width="1200px"
    :visible.sync="detailDialogVisible"
    @open="openDialog"
    @close="closeDialog"
    :before-close="handleClose"
  >
    <el-form
      label-width="200px"
      :model="currencyDetail"
      :rules="rules"
      ref="currencyForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="币种：" prop="info.coin">
            <el-input :value="currencyDetail.info.coin" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="Logo：" prop="info.logo">
            <upload
              :value="currencyDetail.info.logo"
              @input="handleChange('info', 'logo', $event)"
              :data="{
                isSprite: false,
                coinType: currencyDetail.info.coin,
                category: 'coin'
              }"
            ></upload>
          </el-form-item> -->
          <el-form-item label="充值：" prop="info.supportDeposit">
            <el-switch
              :value="currencyDetail.info.supportDeposit"
              @input="handleChange('info', 'supportDeposit', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item label="提现：" prop="info.supportWithdraw">
            <el-switch
              :value="currencyDetail.info.supportWithdraw"
              @input="handleChange('info', 'supportWithdraw', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item label="Memo Needed：" prop="info.memoNeeded">
            <el-switch
              :value="currencyDetail.info.memoNeeded"
              @input="handleChange('info', 'memoNeeded', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="是否支持Memo正则表达式："
            prop="info.supportMemoVerify"
            v-if="currencyDetail.info.memoNeeded"
          >
            <el-switch
              :value="currencyDetail.info.supportMemoVerify"
              @input="handleChange('info', 'supportMemoVerify', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="Memo正则表达式："
            prop="info.memoRegexpExpress"
            v-if="currencyDetail.info.memoNeeded"
          >
            <el-input
              :value="currencyDetail.info.memoRegexpExpress"
              :disabled="!currencyDetail.info.supportMemoVerify"
              @input="handleChange('info', 'memoRegexpExpress', $event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="币种全名：" prop="info.coinFullName">
            <el-input
              :value="currencyDetail.info.coinFullName"
              @input="handleChange('info', 'coinFullName', $event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="币种显示名称：" prop="info.coin">
            <el-input
              :value="currencyDetail.info.coin"
              @input="handleChange('info', 'coin', $event)"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="最小交易额：" prop="info.minimumTradeAmount">
            <el-input-number
              :value="currencyDetail.info.minimumTradeAmount"
              @input="handleChange('info', 'minimumTradeAmount', $event)"
            ></el-input-number>
          </el-form-item> -->
          <el-form-item label="最小充值额：" prop="info.minimumDepositAmount">
            <el-input-number
              :value="currencyDetail.info.minimumDepositAmount"
              @input="handleChange('info', 'minimumDepositAmount', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="提现手续费：" prop="info.withdrawFee">
            <el-input-number
              :value="currencyDetail.info.withdrawFee"
              @input="handleChange('info', 'withdrawFee', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="内部地址提现手续费："
            prop="info.internalWithdrawFee"
          >
            <el-input-number
              :value="currencyDetail.info.internalWithdrawFee"
              @input="handleChange('info', 'internalWithdrawFee', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="单笔提现额度：" required>
            <el-col :span="11">
              <el-form-item prop="info.minWithdrawSingle">
                <el-input-number
                  :value="currencyDetail.info.minWithdrawSingle"
                  @input="handleChange('info', 'minWithdrawSingle', $event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col class="text-center" :span="2">~</el-col>
            <el-col :span="11">
              <el-form-item prop="info.maxWithdrawSingle">
                <el-input-number
                  :value="currencyDetail.info.maxWithdrawSingle"
                  @input="handleChange('info', 'maxWithdrawSingle', $event)"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="当日提现额度：" prop="info.maxWithdrawOneDay">
            <el-input-number
              :value="currencyDetail.info.maxWithdrawOneDay"
              @input="handleChange('info', 'maxWithdrawOneDay', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="确认数：" prop="info.blockConfirm">
            <el-input-number
              :value="currencyDetail.info.blockConfirm"
              @input="handleChange('info', 'blockConfirm', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="区块时间：" prop="info.blockTime">
            <el-input-number
              :value="currencyDetail.info.blockTime"
              @input="handleChange('info', 'blockTime', $event)"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="区块链浏览器hash："
            prop="info.blockChainHashBuilder"
          >
            <el-input
              :value="currencyDetail.info.blockChainHashBuilder"
              @input="handleChange('info', 'blockChainHashBuilder', $event)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="区块链浏览器addr："
            prop="info.blockChainAddrBuilder"
          >
            <el-input
              :value="currencyDetail.info.blockChainAddrBuilder"
              @input="handleChange('info', 'blockChainAddrBuilder', $event)"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="是否支持地址正则表达式："
            prop="info.supportAddrVerify"
          >
            <el-switch
              :value="currencyDetail.info.supportAddrVerify"
              @input="handleChange('info', 'supportAddrVerify', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item label="地址正则表达式：" prop="info.addrRegexpExpress">
            <el-input
              :value="currencyDetail.info.addrRegexpExpress"
              :disabled="!currencyDetail.info.supportAddrVerify"
              @input="handleChange('info', 'addrRegexpExpress', $event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input
              :value="currencyDetail.info.desc"
              :autosize="{ minRows: 4, maxRows: 6 }"
              type="textarea"
              @input="handleChange('info', 'desc', $event)"
            ></el-input>
          </el-form-item> -->
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item label="chains：" prop="info.chains" v-if="currencyDetail.info.code!='USDT'">
    
            <el-input type="primary" placeholder="请输入币种的新链名称（大写）" :value="currencyDetail.info.chains"
            @input="handleChange('info', 'chains', $event)"
            ></el-input>chainsOption
     
          </el-form-item> -->

          <el-form-item label="chain：" prop="info.chain" >
    
            <!-- <el-input type="primary" placeholder="请输入币种的新链名称（大写）" :value="currencyDetail.info.chains"
            @input="handleChange('info', 'chains', $event)"
            ></el-input> -->

            <!-- <el-select @change="handleChange('info', 'chains', $event)" placeholder="请选择"> -->
            <el-select v-model="currencyDetail.info.chain" placeholder="请选择">
                <el-option
                  v-for="item in chainsOption"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!-- <el-form-item label="是否EOS或EOS代币：" prop="eosSerious">
            <el-switch
              :value="currencyDetail.eosSerious"
              @input="handleChange('eosSerious', '', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item> -->
          <!-- <el-form-item
            label="生成代币账户："
            prop="eosSeriousConfig.contractIdentify"
            :rules="[
              {
                message: '请输入EOS代币标识',
                required: currencyDetail.eosSerious
              }
            ]"
          >
            <el-input
              :value="currencyDetail.eosSeriousConfig.contractIdentify"
              @input="
                handleChange('eosSeriousConfig', 'contractIdentify', $event)
              "
              :disabled="!currencyDetail.eosSerious"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="代币精度："
            prop="eosSeriousConfig.precision"
            :rules="[
              {
                message: '请输入EOS代币精度',
                required: currencyDetail.eosSerious
              }
            ]"
          >
            <el-input-number
              :value="currencyDetail.eosSeriousConfig.precision"
              @input="handleChange('eosSeriousConfig', 'precision', $event)"
              :disabled="!currencyDetail.eosSerious"
            ></el-input-number>
          </el-form-item> -->
        </el-col>

        <el-col :span="12">
          <!-- <el-form-item label="是否支持红包：">
            <el-switch
              :value="currencyDetail.info.supportRedPacket"
              @input="handleChange('info', 'supportRedPacket', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item label="单个红包最大金额：">
            <el-input-number
              :value="currencyDetail.info.maxRedPacketAmount"
              @input="handleChange('info', 'maxRedPacketAmount', $event)"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="单个红包最小金额：">
            <el-input-number
              :value="currencyDetail.info.minRedPacketAmount"
              @input="handleChange('info', 'minRedPacketAmount', $event)"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="红包金额精度：">
            <el-input-number
              :value="currencyDetail.info.redPacketAmountPrecision"
              @input="handleChange('info', 'redPacketAmountPrecision', $event)"
            ></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item label="社区URL" prop="info.communityURL">
            <upload v-model="currencyDetail.info.communityURL"></upload>
          </el-form-item>
          <el-form-item label="聊天室ID" prop="info.groupId">
            <el-input v-model="currencyDetail.info.groupId"></el-input>
          </el-form-item> -->
          <el-form-item label="是否支持冻结转账" prop="info.frozenTransfer">
            <el-switch
              :value="currencyDetail.info.frozenTransfer"
              @input="handleChange('info', 'frozenTransfer', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <!-- <el-form-item label="chains：" prop="info.chains" >
    
             <el-input type="primary" placeholder="请输入币种的新链名称（大写）" :value="currencyDetail.info.chains"
              @input="handleChange('info', 'chains', $event)"
             ></el-input>
              
            </el-form-item> -->
             <el-form-item label="source：" prop="info.source">
              <el-select :value="currencyDetail.info.source" 
              @change="sourceChange($event)"
              placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="addressSource：" prop="info.addressSource">
              <el-select :value="currencyDetail.info.addressSource" 
              @change="sourceAddressChange($event)"
              placeholder="请选择">
                <el-option
                  v-for="item in sourceAddressData2"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="udMainCoinType" prop="info.udMainCoinType">
              <el-select clearable @change="udMainCoinTypeChange($event)" v-model="currencyDetail.info.udMainCoinType" placeholder="请选择">
                <el-option
                  v-for="item in udData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="udCoinType" prop="info.udCoinType">
              <el-select clearable @change="udCoinTypeChange($event)" v-model="currencyDetail.info.udCoinType" placeholder="请选择">
                <el-option
                  v-for="item in udData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实际精度：" prop="info.actualPrecision">
              <el-input-number
              v-model="currencyDetail.info.actualPrecision"></el-input-number>
            </el-form-item>
            <el-form-item label="显示精度：" prop="info.displayPrecision">
              <el-input-number
              v-model="currencyDetail.info.displayPrecision"></el-input-number>
            </el-form-item>
            <el-form-item label="币种最大精度：" prop="info.maxPrecision">
              <el-input-number
              v-model="currencyDetail.info.maxPrecision"></el-input-number>
            </el-form-item>
            <el-form-item
            label="是否支持地址正则表达式："
            prop="info.supportAddrVerify"
          >
            <el-switch
              :value="currencyDetail.info.supportAddrVerify"
              @input="handleChange('info', 'supportAddrVerify', $event)"
              active-color="#13ce66"
            ></el-switch>
          </el-form-item>
          <el-form-item label="地址正则表达式：" prop="info.addrRegexpExpress">
            <el-input
              :value="currencyDetail.info.addrRegexpExpress"
              :disabled="!currencyDetail.info.supportAddrVerify"
              @input="handleChange('info', 'addrRegexpExpress', $event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input
              :value="currencyDetail.info.desc"
              :autosize="{ minRows: 4, maxRows: 6 }"
              type="textarea"
              @input="handleChange('info', 'desc', $event)"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('currencyForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Upload from 'components/upload';
import { EOS_SERIOUS_CONFIG } from '../../constants';

const NOT_NUMBER_INPUT = [
  'desc',
  'logo',
  'blockChainHashBuilder',
  'blockChainAddrBuilder',
  'addrRegexpExpress',
  'memoRegexpExpress',
  'contractIdentify',
  'coinFullName'
];

export default {
  name: 'CurrencyDetail',
  components: {
    Upload
  },
  data() {
    return {
      chainsOption:['TRC20','ERC20','BEP20'],
      sourceAddressData2:[],
      options: [{
          value: 'wallet',
          label: 'wallet'
        },
        {
          value: 'cobo',
          label: 'cobo'
        },
        {
          value: 'HDWallet',
          label: 'HDWallet'
        },
      ],
      rules: {
        'info.code': [{ required: true, message: '请输入币种名称' }],
        'info.maxWithdrawOneDay': [
          { required: true, message: '请输入当日提现额度' }
        ],
        'info.maxWithdrawSingle': [
          { required: true, message: '请输入单笔提现最大额度' }
        ],
        'info.coinFullName': [{ required: true, message: '请输入币种全名' }],
        'info.coin': [
          { required: true, message: '请输入币种显示名称' }
        ],
        'info.minWithdrawSingle': [
          { required: true, message: '请输入单笔提现最小额度' }
        ],
        'info.minimumTradeAmount': [
          { required: true, message: '请输入最小交易额' }
        ],
        'info.minimumDepositAmount': [
          { required: true, message: '请输入最充值额' }
        ],
        'info.withdrawFee': [{ required: true, message: '请输入提现手续费' }],
        'info.blockConfirm': [{ required: true, message: '请输入确认数' }],
        'info.blockTime': [{ required: true, message: '请输入区块时间' }],
        'info.blockChainHashBuilder': [
          { required: true, message: '请输区块链浏览器hash地址' }
        ],
        'info.blockChainAddrBuilder': [
          { required: true, message: '请输区块链浏览器address地址' }
        ],
        'info.source': [
          { required: true, message: '请选择source地址' }
        ],
        'info.chain': [
          { required: true, message: '请选择chains地址' }
        ]
      }
    };
  },
  computed: {
    ...mapState('currencySetting', ['detailDialogVisible', 'currencyDetail','chainsData','sourceAddressData','udData']),
   
  },
  watch: {
    sourceAddressData() {
      if (this.detailDialogVisible) {
        this.syncSourceAddressOptions(this.currencyDetail.info.addressSource)
      }
    }
  },
 
  
  methods: {
    ...mapMutations('currencySetting', [
      'toggleDetailDialogVisible',
      'setCurrencyDetail',
    ]),
    ...mapActions('currencySetting', ['update','getChains','detail','getSourceAddress']),
    syncSourceAddressOptions(currentValue = '') {
      this.sourceAddressData2 = [...new Set([...this.sourceAddressData, currentValue].filter(Boolean))]
    },
    
   async openDialog(){
 
     const resDetail=await this.detail({coinType:localStorage.getItem('coinType'),chain:localStorage.getItem('chain')})
          this.chainsOption=[...new Set([...this.chainsData,resDetail.info.chain?resDetail.info.chain:'',resDetail.info.coin])]
          this.syncSourceAddressOptions(resDetail.info.addressSource)
    },
    mounted () {
      this.getSourceAddress()
    },
    closeDialog() {
      // this.chainsOption=[]
      this.syncSourceAddressOptions()
      this.toggleDetailDialogVisible(false);
    },
    btnChange(e){
console.log('btn-e',e);
    },
   async sourceChange(e){
console.log('source-change',e);
if(e=='cobo'){
  
  this.chainsOption=[this.currencyDetail.info.coin]
  this.currencyDetail.info.chain=this.currencyDetail.info.coin
}else{
  const resDetail=await this.detail({coinType:localStorage.getItem('coinType'),chain:localStorage.getItem('chain')})
this.chainsOption=[...new Set(['TRC20','ERC20','BEP20',...this.chainsData,resDetail.info.chain?resDetail.info.chain:'',resDetail.info.coin])]
}
      this.currencyDetail.info.source=e
    },
    sourceAddressChange(e){
      this.currencyDetail.info.addressSource=e
    },
    udMainCoinTypeChange(e){
      this.currencyDetail.info.udMainCoinType=e
    },
    udCoinTypeChange(e){
      this.currencyDetail.info.udCoinType=e
    },
    
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {

            this.closeDialog()
            done();
          })
          .catch(_ => {});
      },
    handleSave(formName) {
    
// this.$set(this.currencyDetail.info.chains,'chains',this.currencyDetail.info.chains)
// this.$set(this.currencyDetail.info.source,'source',this.currencyDetail.info.source)
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.update(this.currencyDetail).then(() => {
            this.$message.success('修改成功！');
            this.toggleDetailDialogVisible(false);
            this.$emit('refresh');
          });
        }
      });
    },
    handleChange(type, key, value) {
      if (type === 'eosSerious') {
        if (value) {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            eosSerious: true,
            info: {
              ...this.currencyDetail.info,
              memoNeeded: true,
              blockChainHashBuilder: EOS_SERIOUS_CONFIG.hash,
              blockChainAddrBuilder: EOS_SERIOUS_CONFIG.address,
              supportAddrVerify: true,
              addrRegexpExpress: EOS_SERIOUS_CONFIG.regexp,
              blockConfirm: 1,
              blockTime: 2
            }
          });
        } else {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            eosSerious: false,
            info: {
              ...this.currencyDetail.info,
              memoNeeded: false,
              blockChainHashBuilder: '',
              blockChainAddrBuilder: '',
              supportAddrVerify: false,
              addrRegexpExpress: '',
              blockConfirm: '',
              blockTime: ''
            }
          });
        }
      } else {
        if (type === 'info' && key === 'supportMemoVerify') {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            info: {
              ...this.currencyDetail.info,
              supportMemoVerify: value,
              memoRegexpExpress: value
                ? this.currencyDetail.info.memoRegexpExpress
                : ''
            }
          });
        } else if (type === 'info' && key === 'supportAddrVerify') {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            info: {
              ...this.currencyDetail.info,
              supportAddrVerify: value,
              addrRegexpExpress: value
                ? this.currencyDetail.info.addrRegexpExpress
                : ''
            }
          });
        }
        // 添加chains判断
        else if (type === 'info' && key === 'chain') {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            info: {
              ...this.currencyDetail.info,
             chain:[value]
            }
          });
        }
         else {
          this.setCurrencyDetail({
            ...this.currencyDetail,
            [type]: {
              ...this.currencyDetail[type],
              [key]: value
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
